import {
  CircularProgress,
  ClickAwayListener,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import useSlotCreates from 'core/hooks/useSlotCreates';
import useSlotDeletes from 'core/hooks/useSlotDeletes';
import { useErrorNotifications } from 'core/http';
import Tire from 'Elements/Tire/Tire';

type Props = {
  id: number | null;
  axleId: number;
  position: number;
};

const AddTire = styled.div`
  height: 86.25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default function Slot({ id, axleId, position }: Props) {
  const showErrorNotification = useErrorNotifications();
  const [slotId, setSlotId] = useState(id);
  const [creating, setCreating] = useState(false);
  const create = useSlotCreates();

  const [deleting, setDeleting] = useState(false);
  const deleteSlot = useSlotDeletes();

  const [showPopper, togglePopper] = useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const onAddClick = useCallback(() => {
    if (creating) return;

    setCreating(true);

    return create(axleId, position)
      .then(slot => setSlotId(slot.id))
      .catch(showErrorNotification)
      .finally(() => setCreating(false));
  }, [axleId, create, creating, position, showErrorNotification]);

  const onDeleteClick = useCallback(() => {
    if (deleting) return;

    if (slotId == null) return;

    setDeleting(true);

    return deleteSlot(axleId, slotId)
      .then(() => setSlotId(null))
      .catch(showErrorNotification)
      .finally(() => {
        setDeleting(false);
        togglePopper(false);
      });
  }, [axleId, deleteSlot, deleting, showErrorNotification, slotId]);

  return (
    <div>
      {slotId != null ? (
        <div ref={anchorRef} onClick={() => togglePopper(true)}>
          <Tire></Tire>
          <Popper
            open={showPopper}
            anchorEl={anchorRef.current}
            transition
            disablePortal
            placement="left-start"
          >
            <Paper>
              <ClickAwayListener onClickAway={() => togglePopper(false)}>
                <MenuList disablePadding>
                  <MenuItem onClick={onDeleteClick} disabled={deleting}>
                    Poista
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Popper>
        </div>
      ) : (
        <AddTire onClick={onAddClick}>
          {creating ? <CircularProgress /> : <AddCircle />}
        </AddTire>
      )}
    </div>
  );
}
